import RecognitionSearchBar from "./RecognitionSearchBar";

export default RecognitionSearchBar;
